// src/components/games/GameLanguageSupport.js

function GameLanguageSupport({ supportedLanguages = [] }) {
  return (
    <div className="bg-neutral-800 p-4 rounded">
      <h4 className="text-md font-semibold mb-2">지원 언어</h4>
      <table className="w-full text-sm text-gray-300 border-collapse table-fixed">
        <thead>
          <tr className="border-b border-gray-600 text-left">
            <th className="py-2 w-1/4 text-left">언어</th>
            <th className="py-2 w-1/4 text-center">인터페이스</th>
            <th className="py-2 w-1/4 text-center">오디오</th>
            <th className="py-2 w-1/4 text-center">자막</th>
          </tr>
        </thead>
        <tbody>
          {supportedLanguages.map((lang, idx) => (
            <tr key={idx} className="border-b border-gray-700">
              <td className="py-1 w-1/4 text-left text-white">{lang.name}</td>
              <td className="py-1 text-center">{lang.ui ? "✔️" : ""}</td>
              <td className="py-1 text-center">{lang.audio ? "✔️" : ""}</td>
              <td className="py-1 text-center">{lang.subtitle ? "✔️" : ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default GameLanguageSupport;
